<template>
  <div>
    <!----询比单信息------>
    <div v-if="showOrder" class="card no-margin m-t-20">
      <div class="section">
        <div class="section-title">
          <base-section-title title="询比单信息" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="orderInfo"
            :option="orderOptions"
            :el-attrs="{
              size: 'medium',
              column: 1,
              labelStyle: {
                width: '140px',
                whiteSpace: 'nowrap',
                textAlign: 'right'
              }
            }"
          />
        </div>
      </div>
    </div>

    <order-winner-template
      :table-data="detailVoList"
      :winner-info="winnerForm"
      :require-tax="requireTax"
      :is-dollar="isDollar"
      :round-id="currentRound.roundId"
      :winner-id="winnerId"
      :item-schema-list="localItemSchemaList"
      :is-show-modify-info="isModify"
      :internal-attachment-ids="internalAttachmentIds"
      :is-table-grey-features="isTableGreyFeatures"
      :order-id="orderId"
      :request-query="requestQuery"
      :invite-supplier-list="inviteList"
      :is-service-fee-setting="isServiceFeeSetting || isServiceFee"
    />

    <!-- 审批备注 -->
    <record-remark
      v-if="requestQuery.pageFrom == 'auditDetail'"
      class="m-t-16"
      :remark-list="remarkList"
    />

    <!-- 审批历史 -->
    <record-history
      v-if="requestQuery.pageFrom == 'auditDetail'"
      :record-list="flowListing"
    />
  </div>
</template>

<script>
import OrderWinnerTemplate from '@/components/inquiry/OrderWinnerTemplate'
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import RecordHistory from '@/components/common/RecordHistory'
import RecordRemark from '@/components/common/RecordRemark'

import {
  inquiryRequireTaxDict,
  inquiryWayDict
} from '@/dictionary/project/inquiry'
import { projectTypeDict, currencyTypeDict } from '@/dictionary/project/common'
import { chargeTypeDict, costSubjectDict } from '@/dictionary/company'

import {
  getNewestWinnerInfoApi,
  getInquiryOrderApi
} from '@/api/procure/inquiry'
import { cloneDeep } from 'lodash'
export default {
  name: 'InquiryWinnerInfo',

  components: {
    OrderWinnerTemplate,
    BaseSectionTitle,
    RecordHistory,
    RecordRemark
  },

  props: {
    requestQuery: {
      type: Object,
      required: true
    },

    showOrder: {
      type: Boolean,
      default: true
    },
    isByOrderId: {
      type: Boolean,
      default: true
    },

    // 字段设置
    itemSchemaList: {
      type: Array,
      default: () => []
    },

    // 备注列表
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    },

    isWuling: {
      type: Boolean,
      default: false
    },

    inviteSupplierList: {
      type: Array,
      default: () => []
    },

    isServiceFeeSetting: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      orderInfo: {},
      flowListing: [],
      chargeList: [],
      orderOptions: [
        {
          label: '询比单名称',
          prop: 'orderName'
        },
        {
          label: '询比单编号',
          prop: 'orderCode'
        },
        {
          label: '项目类型',
          prop: 'projectType',
          filter: value => projectTypeDict.translate(value).label || ' - '
        },
        {
          label: '收货地址',
          prop: 'address',
          filter: value => {
            if (value?.receivingCountry === '中国') {
              return value?.receivingProvince
                ? `${value?.receivingProvince} ${value?.receivingCity} ${value?.receivingArea}`
                : ' - '
            } else {
              return value?.receivingCountry
            }
          }
        },
        {
          label: '详细地址',
          prop: 'address.address'
        }
      ],

      requireTax: '',
      detailVoList: [], // 成交的品目与供应商信息列表
      // 成交表单
      winnerForm: {
        publicity: 0, // 是否发布公示，1是，0不是
        noticeTitle: '', // 公示标题
        noticeContent: '', // 公示内容
        itemList: [], // 授标列表
        awardType: '' // 授标方式
      },
      winnerId: '',
      localItemSchemaList: [],
      isDollar: false,
      currentRound: {},
      isTableGreyFeatures: false
    }
  },

  computed: {
    orderId() {
      return this.requestQuery.orderId
    },

    /**
     * 是否是修改成交供应商
     */
    isModify() {
      return (
        this.requestQuery?.businessInfo?.businessNode ===
        'submit_modify_winner_supplier'
      )
    },

    internalAttachmentIds() {
      return this.orderInfo?.internalAttachmentIds || []
    },

    inviteList() {
      if (this.inviteSupplierList.length) {
        return this.inviteSupplierList
      }
      return this.orderInfo.inviteList || []
    },

    // 计费配置中平台服务费是否为发布设置
    isServiceFee() {
      return this.chargeList?.some(charge => {
        if (
          charge.costSubject === costSubjectDict.SERVICE_FEE.value &&
          charge.chargeType === chargeTypeDict.COMPANY.value
        ) {
          return true
        }
      })
    }
  },

  watch: {
    'requestQuery.orderInfo': {
      handler: function(val) {
        if (val) {
          this.orderInfo = this.requestQuery?.orderInfo?.order || {}
          this.requireTax =
            this.orderInfo.offerRequireTax === inquiryRequireTaxDict.YES.value
          this.isDollar =
            this.orderInfo.currencyType === currencyTypeDict.DOLLAR.value

          // 默认取最新轮次
          const len = this.requestQuery?.orderInfo?.roundList?.length
          if (len > 0) {
            this.currentRound = this.requestQuery?.orderInfo?.roundList[len - 1]
          }

          this.getWinnerInfo()
        }
      },
      immediate: true
    },

    'requestQuery.orderId': {
      handler: function(val) {
        if (this.isByOrderId && val) {
          this.getOrderInfo()
          this.getWinnerInfo()
        }
      },
      immediate: true
    },

    itemSchemaList: {
      handler(val) {
        if (val?.length > 0) {
          this.localItemSchemaList = cloneDeep(val)
        }
      },
      deep: true,
      immediate: true
    },

    isWuling(val) {
      this.isTableGreyFeatures = val
    }
  },

  methods: {
    /**
     * 获取询比单信息
     */
    getOrderInfo() {
      getInquiryOrderApi({ orderId: this.orderId })
        .then(res => {
          this.orderInfo = res?.data?.order || {}
          this.flowListing = res?.data?.flowListing || []
          this.requireTax =
            this.orderInfo.offerRequireTax === inquiryRequireTaxDict.YES.value
          this.isDollar =
            this.orderInfo.currencyType === currencyTypeDict.DOLLAR.value
          if (
            this.orderInfo.inquiryType === inquiryWayDict.INVITE_INQUIRY.value
          ) {
            this.orderInfo.inviteList = res.data?.inviteList || []
          }
          this.chargeList = res?.data?.chargeList || []

          // 默认取最新轮次
          const len = res?.data?.roundList?.length
          if (len > 0) {
            this.currentRound = res?.data?.roundList[len - 1]
          }

          this.localItemSchemaList = res?.data?.itemSchemaList || []
          this.isTableGreyFeatures = Boolean(res.data?.order?.isWuling)
          this.$emit('isWuling', this.isTableGreyFeatures)
        })
        .catch(err => {
          console.error('获取询比单信息失败', err)
          this.$message.error(err.message || '获取询比单信息')
        })
    },
    // 获取成交信息
    getWinnerInfo() {
      const ids = { orderId: this.orderId }
      getNewestWinnerInfoApi(ids)
        .then(res => {
          const data = res.data || {}
          this.winnerForm = Object.assign({}, this.winnerForm, data)
          this.detailVoList = data.detailDtoList || []
          this.winnerId = data.calibrationId
          this.$emit('setWinnerInfo', data)
        })
        .catch(err => {
          if (err) {
            this.$message.error(err.message || '获取成交信息失败')
          } else {
            console.log('winner info error >>> ', err)
          }
        })
    }
  }
}
</script>

<style scoped></style>
